<template>
  <header class="header" id="test2" >
    <div id="nav">
      <b-navbar  toggleable="md" class="nav-background">
        <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>

        <b-navbar-brand>
          <img src="../../assets/Askoylogo2.png" style="height: 40px" alt="Askøy Tømrer Service">
        </b-navbar-brand>

        <b-collapse is-nav id="nav_collapse" v-model="showCollapse">
          <b-navbar-nav id="test1"  class="ml-auto">
            <b-nav-item active to="/">
              <span v-on:click="closeMenu('1')" v-bind:style="{ color: isHidden1 }">Hjem</span>
            </b-nav-item>
            <b-nav-item active to="/Omoss">
              <span v-on:click="closeMenu('2')" v-bind:style="{ color: isHidden2 }">Om oss</span>
            </b-nav-item>
            <b-nav-item active to="/Rreferanse">
              <span v-on:click="closeMenu('3')" v-bind:style="{ color: isHidden3 }">Rreferanse</span>
            </b-nav-item>
            <b-nav-item active to="/Kontakt">
              <span v-on:click="closeMenu('4')" v-bind:style="{ color: isHidden4 }">Kontakt</span>
            </b-nav-item>
            <b-nav-item bg-variant="white" active to="/Tjenester">
              <span v-on:click="closeMenu('5')" v-bind:style="{ color: isHidden5 }">Tjenester</span>
            </b-nav-item>
            <b-nav-item active to="/SalgProdukter">
              <span v-on:click="closeMenu('6')" v-bind:style="{ color: isHidden6 }">Salg produkter</span>
            </b-nav-item>
           </b-navbar-nav>
        </b-collapse>
      </b-navbar>
    </div>
  </header>
</template>

<script>
export default {
  name: "Header",

  data() {
    return {
      isHidden1: "black",
      isHidden2: "black",
      isHidden3: "black",
      isHidden4: "black",
      isHidden5: "black",
      isHidden6: "black",
      colorx: "red",
      colorx2: "blue",
      showCollapse: true
    };
  },
  methods: {
    closeMenu(GHidden) {
      this.colorx = "blue";
      this.showCollapse = false;

      this.isHidden1 = "black";
      this.isHidden2 = "black";
      this.isHidden3 = "black";
      this.isHidden4 = "black";
      this.isHidden5 = "black";
      this.isHidden6 = "black";

      if (GHidden == "1") {
        this.isHidden1 = "blue";
      }
      if (GHidden == "2") {
        this.isHidden2 = "blue";
      }
      if (GHidden == "3") {
        this.isHidden3 = "blue";
      }
      if (GHidden == "4") {
        this.isHidden4 = "blue";
      }
      if (GHidden == "5") {
        this.isHidden5 = "blue";
      }
      if (GHidden == "6") {
        this.isHidden6 = "blue";
      }
    }
  }
};
</script>

<style  scoped>
.nav-background {
 background: rgb(134, 192, 184);
   font-family: sans-serif;
   font-size: 20px;
}

.header {
  background: #333;
  color: #fff;
  text-align: center;
  padding: 0px;
 

}

.header a {
  color: #fff;
  padding-right: 5px;
  text-decoration: none;
}
.header a:hover{
  color: rgb(211, 224, 213);
  text-decoration: none;
 
}
.b-navbar-nav {
  display: flex;
}
@media (max-width: 768px) {
  .nav-background {

  background:  rgb(208, 233, 212);
   font-family: sans-serif;
   font-size: 20px;
}

.header {
  background:rgb(134, 192, 184);
  text-align: left;
 
}

#test1 {
  background: rgb(134, 192, 184);
  padding-left: 5px;
  text-decoration: none;

}
#nav {
  background: red;
  padding-left: 0px;
  text-decoration: none;

}

}
</style>

